import React from 'react'
import {useDropzone} from 'react-dropzone'
import {KYCAccountDocTypeDataType, KYCDetailsUploadDocumentsDataType, uploadDocumentsArrayDataType} from '../KYCDetailsDataType'

const KYCDetailsUploadDocuments = ({
  formik,
  KYCAccountDocType,
  setUploadDocuments,
  uploadDocuments,
  setKYCAccountDocType,
}: KYCDetailsUploadDocumentsDataType) => {
  // dropzone code start
  const {acceptedFiles, fileRejections, getRootProps, getInputProps, isDragActive} = useDropzone({
    maxFiles: 1,
    accept: {
      'image/jpeg': [],
      'image/png': [],
      'application/pdf': [],
    },
  })
  const acceptedFileItems = acceptedFiles.map((file: File) => {
    return (
      <li key={file.name}>
        {file.name} - {file.size} bytes
      </li>
    )
  })
  const fileRejectionItems = fileRejections.map(
    ({file, errors}: {file: File; errors: {code: string; message: string}[]}) => {
      return (
        <li key={file.name}>
          {file.name} - {file.size} bytes
          <ul>
            {errors.map((e: any) => (
              <li key={e.code}>{e.message}</li>
            ))}
          </ul>
        </li>
      )
    }
  )
  // dropzone code ends

  // function to upload the document (onclick of upload document button)
  const handleUploadDocument = () => {
    if (acceptedFiles.length > 0 && formik.values.account_kyc_document_type_uuid) {
      const reader = new FileReader()
      reader.onloadend = async () => {
        const base64String = reader.result
        const docName = KYCAccountDocType.find(
          (option) =>
            option.account_kyc_document_type_uuid === formik.values.account_kyc_document_type_uuid
        )
        const newDocUpload: uploadDocumentsArrayDataType = {
          account_kyc_document_type_uuid: formik.values.account_kyc_document_type_uuid,
          // @ts-ignore
          file: base64String.split(',')[1],
          fileName: acceptedFiles[0].name,
          documentTypeName: docName?.account_kyc_document_type_name,
        }
        setUploadDocuments([...uploadDocuments, newDocUpload])
        setKYCAccountDocType(
          KYCAccountDocType.filter(
            (obj) =>
              obj.account_kyc_document_type_uuid !== formik.values.account_kyc_document_type_uuid
          )
        )
        acceptedFiles.pop()
        formik.setFieldValue('account_kyc_document_type_uuid', '')
      }
      reader.readAsDataURL(acceptedFiles[0])
    } else {
      formik.setFieldError('account_kyc_document_type_uuid', 'Select document type')
    }
  }
  return (
    <div className='fv-row mb-2'>
      {/*Begin::Form Group property type */}
      <div className='fv-row mb-2'>
        <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
          <span>Document Type</span>
          <i
            className='fas fa-exclamation-circle ms-2 fs-7'
            data-bs-toggle='tooltip'
            title='Choose document type'
          ></i>
        </label>
        <select
          className='form-select form-select-solid'
          placeholder='Choose document type'
          {...formik.getFieldProps('account_kyc_document_type_uuid')}
          name='account_kyc_document_type_uuid'
        >
          <option className='bg-color-gray' value=''>
            Choose document type
          </option>
          {KYCAccountDocType?.map((item: KYCAccountDocTypeDataType) => {
            return (
              <option
                key={item.account_kyc_document_type_uuid}
                value={item.account_kyc_document_type_uuid}
              >
                {item.account_kyc_document_type_name}
              </option>
            )
          })}
        </select>
        <div className='h-20px'>
          {formik.errors.account_kyc_document_type_uuid && (
            <div className='fv-help-block color-red'>
              {formik.errors.account_kyc_document_type_uuid}
            </div>
          )}
        </div>
      </div>
      {/*End::Form Group property type */}
      {/*begin::Dropzone field */}
      <div className='border border-2 rounded border-dashed row p-2 bg-white mx-2 mb-4'>
        <section className='border border-2 rounded border-primary border-dashed h-100 symbol bg-light-primary'>
          <div
            {...getRootProps({
              className: 'py-4 d-flex flex-column justify-content-center align-items-center',
            })}
          >
            <input {...getInputProps()} />
            {isDragActive ? (
              <p>Drop the files here...</p>
            ) : (
              <p>Drag and drop files here, or click to select files</p>
            )}
            <i className='bi bi-file-earmark-arrow-up-fill fs-4x btn btn-active-color-primary py-0 mb-3'></i>
            <span className='text-primary fs-7'>Type: *.jpeg, *.jpg, *.png or *.pdf only</span>
            <span className='text-primary fs-7'>Max document:1</span>
          </div>
        </section>
      </div>
      <aside className='px-5'>
        {acceptedFileItems.length > 0 && (
          <div className='d-flex justify-content-between'>
            <div className='pt-2'>
              <h4>Document is ready to upload</h4>
              <ul>{acceptedFileItems}</ul>
            </div>
            <div className='pt-2'>
              <button
                type='button'
                className='btn btn-sm fw-bold btn-primary d-flex justify-content-center align-items-center'
                data-kt-stepper-action='submit'
                onClick={handleUploadDocument}
              >
                <i className='bi bi-file-earmark-arrow-up fs-2 me-2'></i>
                <span className='fs-6'>Upload document</span>
              </button>
            </div>
          </div>
        )}
        {fileRejectionItems.length > 0 && (
          <div className='pt-2'>
            <span className='fv-help-block color-red'>
              Upload only one file or select files with allowed formats only
            </span>
          </div>
        )}
      </aside>
      {/*end::Dropzone field */}
    </div>
  )
}

export default KYCDetailsUploadDocuments
